export const ROLE_PREFIX = 'ROLE_';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/role.constants.ts